$(document).ready(() => {
  $('.contact-form .hide-other').hide();

  $('.contact-form').on('change', '#how', function() {
    if($(this).val() == 'Other') {
      $('.contact-form .hide-other').show();
    } else {
      $('.contact-form .hide-other').hide();
    }
  });

  $(".contact-form").validate({
    rules: {
      field: {
        required: true,
      },
      email: {
        email: true,
      },
    },
  });

  $(document).on('submit', '.contact-form', function(e) {
    e.preventDefault();

    var form = $(this);
    var formdata = false;
    if (window.FormData){
      formdata = new FormData(form[0]);
    }

    $.ajax({
      url: form.attr('action'),
      type: form.attr('method'),
      data: formdata ? formdata : form.serialize(),
      cache: false,
      contentType: false,
      processData: false,
      beforeSend:function( ) {
        $('.button').html('Processing');
      },
      success:function(data) {
        $('#results').html(data);
        $('.button').html('Send');
        $('.form').trigger('reset');
      },
      error:function() {
        $('#results').html('Sorry, there was an error');
        $('.button').html('Send');
      },
    });
  });
});
